import React from "react";
import { AutoComplete, InputNumber, Input } from "antd";

class ContributionRow extends React.Component {
  constructor(props) {
    super(props);
    this.fundSource = this.props.funds.map(f => f.description);
    this.state = {
      fundSource: this.fundSource
    };
    this.currentValue = 0;
    this.currentFund = "";
    this.handleFundOnFocus = this.handleFundOnFocus.bind(this);
    this.handleAmountOnBlur = this.handleAmountOnBlur.bind(this);
    this.handleFundOnBlur = this.handleFundOnBlur.bind(this);
    this.handleAmountOnFocus = this.handleAmountOnFocus.bind(this);
  }

  handleAmountOnBlur = e => {
    if (e.target.value !== this.currentValue) {
      let newData = {
        contributionLineId: this.props.line.contributionLineId,
        amount: parseFloat(e.target.value || 0 )
      };
      this.props.rowUpdate(newData);
    }
  };

  handleAmountOnFocus = e => {
    this.currentValue = e.target.value;
  };

  handleFundOnBlur = value => {
    if (value !== this.currentFund) {
      let newData = {
        contributionLineId: this.props.line.contributionLineId,
        fund: value 
      };
      this.props.rowUpdate(newData);
    }
  };

  handleFundOnFocus = e => {
    this.currentFund = e.target.value;
  };

  handleSearch = value => {
    //console.log("handlSerch: " + value)
    const allFunds = this.props.funds.map(f => f.description);
    const fundSource = allFunds.filter(i => {
      return i.toUpperCase().includes(value.toUpperCase());
    });
    this.setState({
      fundSource,
      value
    });
  };

  render() {
    const { fundSource } = this.state;
    //console.log("contribution row render: " + this.props.line.fund)
    return (
      <tr>
        <td>
          <AutoComplete
            dataSource={fundSource}
            defaultValue={this.props.line.fund}
            onSearch={this.handleSearch}
            onBlur={this.handleFundOnBlur}
          >
            <Input onFocus={this.handleFundOnFocus} />
          </AutoComplete>
        </td>
        <td>
          <InputNumber
            defaultValue={this.props.line.amount}
            min={0}
            step={1}
            onBlur={this.handleAmountOnBlur}
            onFocus={this.handleAmountOnFocus}
          />
        </td>
      </tr>
    );
  }
}

export default ContributionRow;
